import { FacetedFilterOption } from "@/components/button-faceted-filter";
import { getPlatformBrandColor } from "@/lib/platform-brand-colors";
import { cn } from "@/lib/utils";

export function PlatformIcons({
  options,
}: {
  options: FacetedFilterOption[];
}): React.ReactElement | null {
  return (
    <div className="flex gap-1.5">
      {options.map((opt) => {
        const Icon = opt.icon;
        return Icon ? (
          <Icon
            key={opt.value}
            className={cn("w-4 h-4", getPlatformBrandColor(opt.value))}
          />
        ) : null;
      })}
    </div>
  );
}
